//
// Generated class PaymentEntity
//

/// <reference path="PaymentEntity_ManagedObject.ts" />

enum PaymentEntityType
{
    DualLink = -1,
    CashOnDelivery = 0,
    Proxy = 1,
    Redsys = 2,
    Stripe = 3,
    PayPal = 4,
    Adyen = 5,
}

/// The channels an entity may be offered in. A bitmask: an entity can cover
/// several, and two entities of the same type and environment must not share
/// any of them.
enum PaymentEntityScope
{
    none = 0,
    manager = 1,    // invoice link payments
    pos = 2,
    online = 4,     // the ordering web
    tapToPay = 8,
}

/// Where the entity stands in its onboarding. Written by the servers that
/// drive it, never by the manager — it is shown, not edited.
enum PaymentEntityStatus
{
    none = 0,
    created = 1,    // created on the payment platform
    validated = 2,  // the platform verified the account holder
    ready = 3,      // a payment can actually be charged
    error = -1,
}

class PaymentEntity extends PaymentEntity_ManagedObject
{
    static scopeStringForScope(scope:PaymentEntityScope):string {

        switch (scope){
            case PaymentEntityScope.manager: return MIOLocalizeString("MANAGER", "MANAGER");
            case PaymentEntityScope.pos: return MIOLocalizeString("POS", "POS");
            case PaymentEntityScope.online: return MIOLocalizeString("ONLINE", "ONLINE");
            case PaymentEntityScope.tapToPay: return MIOLocalizeString("TAP TO PAY", "TAP TO PAY");
        }

        return "";
    }

    static statusStringForStatus(status:PaymentEntityStatus):string {

        switch (status){
            case PaymentEntityStatus.none: return MIOLocalizeString("NOT CONFIGURED", "NOT CONFIGURED");
            case PaymentEntityStatus.created: return MIOLocalizeString("PENDING VALIDATION", "PENDING VALIDATION");
            case PaymentEntityStatus.validated: return MIOLocalizeString("PENDING PAYMENT METHODS", "PENDING PAYMENT METHODS");
            case PaymentEntityStatus.ready: return MIOLocalizeString("READY", "READY");
            case PaymentEntityStatus.error: return MIOLocalizeString("ERROR", "ERROR");
        }

        return MIOLocalizeString("UNKNOWN", "UNKNOWN");
    }

    static typeForEntity(entity:PaymentEntity):PaymentEntityType {
        if (entity instanceof AdyenPaymentEntity) return PaymentEntityType.Adyen;
        if (entity instanceof CashOnDeliveryPaymentEntity) return PaymentEntityType.CashOnDelivery;
        if (entity instanceof ProxyPaymentEntity) return PaymentEntityType.Proxy;

        return PaymentEntityType.DualLink;
    }

    get type():PaymentEntityType { return PaymentEntity.typeForEntity(this); }

    /// Only the types onboarded on an external platform carry a status the
    /// venue has to wait for; the rest are usable as soon as they exist.
    get requiresOnboarding():boolean { return this instanceof AdyenPaymentEntity; }

    get isReady():boolean {
        if (this.requiresOnboarding == false) return this.status != PaymentEntityStatus.error;
        return this.status == PaymentEntityStatus.ready;
    }

    hasScope(scope:PaymentEntityScope):boolean { return (this.scope & scope) != 0; }

    setScope(scope:PaymentEntityScope, on:boolean) {
        this.scope = on ? (this.scope | scope) : (this.scope & ~scope);
    }

    static typeStringForType(type:PaymentEntityType):string {

        switch (type){
            case PaymentEntityType.DualLink: return "DUAL LINK";
            case PaymentEntityType.CashOnDelivery: return MIOLocalizeString("CASH ON DELIVERY", "CASH ON DELIVERY");
            case PaymentEntityType.Proxy: return MIOLocalizeString("PROXY", "PROXY");
            case PaymentEntityType.Redsys: return "Redsys";
            case PaymentEntityType.Stripe: return "Stripe";
            case PaymentEntityType.PayPal: return "PayPal";
            case PaymentEntityType.Adyen: return "Adyen";
        }
    }

    static supportedTypesForCurrentRegion() : PaymentEntityType[] {        
        return [PaymentEntityType.Adyen, PaymentEntityType.CashOnDelivery];

        /*
        let region = MIOLocale.currentLocale().countryCode;
        switch (region) {
            case "ES": 
                return [
                    // PaymentEntityType.DualLink,
                    PaymentEntityType.CashOnDelivery,
                    // PaymentEntityType.Redsys,
                    // PaymentEntityType.Stripe,
                    // PaymentEntityType.PayPal,
                    PaymentEntityType.Adyen
                ];            

            case "NL": 
                return [
                    // PaymentEntityType.DualLink,
                    PaymentEntityType.CashOnDelivery,
                    // PaymentEntityType.Redsys,
                    // PaymentEntityType.Stripe,
                    // PaymentEntityType.PayPal,
                    PaymentEntityType.Adyen
                ];            
        }                
        return [];
        */
    }

    configValues() : any {
        if (this.config == null) return {};
        return JSON.parse(this.config);
    }

    setConfigValues(values:any) {
        this.config = JSON.stringify(values);
    }
}
